import { SkeletonText, Text } from "@chakra-ui/react";
import ProfileCard, {
  ProfileCardHeader,
} from "components/profile/profile-card";
import type { CompanyProfile } from "types/api/company/details/overview";

interface DescriptionCardProps {
  isLoaded: boolean;
  companyProfile: CompanyProfile;
}

const DescriptionCard = ({
  isLoaded,
  companyProfile,
}: DescriptionCardProps) => (
  <ProfileCard>
    <ProfileCardHeader>Description</ProfileCardHeader>
    {isLoaded ? (
      <Text fontSize="md" lineHeight={1.66} whiteSpace="pre-wrap">
        {companyProfile?.summary}
      </Text>
    ) : (
      <SkeletonText
        lineHeight={1.66}
        noOfLines={4}
        spacing={2}
        skeletonHeight="20px"
      />
    )}
  </ProfileCard>
);

export default DescriptionCard;
